export default function htmlParser(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    let chairpersons = [];
    let others = [];
    let moreInfo = "";
    let jury = [];
    let leaders = [];
    let panelists = [];
    let experts = [];

    const moreInfoElement = doc.querySelector("i");
    if (moreInfoElement?.innerText) {
        let text = moreInfoElement.innerText;
        if (moreInfoElement.parentElement.tagName == "BODY") {
            moreInfo = text;
        }
    }

    const titles = ['prof.', 'dr', 'hab.', 'n.', 'med.', 'med', 'lek.', 'mgr'];

    const splitNameAndCity = (rest) => {
        rest = (rest || '').trim();

        let city = '';
        const cityMatch = rest.match(/\(([^()]*)\)\s*$/);
        if (cityMatch) {
            city = cityMatch[1].trim();
            rest = rest.slice(0, cityMatch.index).trim();
        }

        const nameParts = rest.split(/\s+/).filter(part => part && !titles.includes(part.toLowerCase()));
        const nameLength = nameParts.length;

        let name = '';
        if (nameLength >= 2) {
            name = [nameParts[nameLength - 2], nameParts[nameLength - 1]].join(' ');
        } else if (nameLength === 1) {
            name = nameParts[0];
        }

        return {name, city};
    }

    const returnPersons = (elements, text, arrayToPush) => {
        if (!elements || !text || !arrayToPush) return;
        elements.forEach(p => {
            const textContent = p.textContent;
            const start = textContent.indexOf(text);
            if (start !== -1) {
                arrayToPush.push(splitNameAndCity(textContent.substring(start + text.length)));
            }
        });
    }

    const chairpersonElements = doc.querySelectorAll('p:has(u)');

    returnPersons(chairpersonElements, 'Prowadzący sesję', leaders);

    returnPersons(chairpersonElements, 'Przewodniczący', chairpersons);

    returnPersons(chairpersonElements, 'Jury', jury);

    returnPersons(chairpersonElements, 'Paneliści', panelists);

    returnPersons(chairpersonElements, 'Ekspert', experts);


    let allParagraphs = Array.from(doc.querySelectorAll('p'));
    let newElements = [];

    allParagraphs.forEach(e => e.innerHTML.includes('Panel dyskusyjny') ? newElements.push(e) : console.log(''))

    newElements.forEach(paragraph => {
        let textContent = paragraph.childNodes[2]?.textContent;

        if (textContent && typeof textContent === "string") {
            others.push(splitNameAndCity(textContent));
        }
    });


    return {chairpersons, others, moreInfo, jury, leaders, panelists, experts};

}
